import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=dfa0accc&scoped=true&"
import script from "./GeneralInfo.vue?vue&type=script&lang=js&"
export * from "./GeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfo.vue?vue&type=style&index=0&id=dfa0accc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa0accc",
  null
  
)

component.options.__file = "GeneralInfo.vue"
export default component.exports